import styled from '@emotion/styled';
import { Skeleton } from 'antd';
import PropTypes from 'prop-types';
import { formatMinToHours } from '../../utils/common_functions';

const Card = styled.div`
  width: 100%;
  height: fit-content;
  display: flex;
  flex-direction: column;
  border-radius: 12px;
  padding: 16px;
  /* border-left: 4px solid ${(props) => props.theme.primaryColor || '#007bff'}; */
  box-shadow: rgba(0, 0, 0, 0.1) 0px 8px 20px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px;
  background: #fff;
  transition: all 0.3s ease;
  &:hover {
    transform: translateY(-1.2px);
    box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 5px 0px, rgba(0, 0, 0, 0.1) 0px 0px 1px 0px;
  }
`;

const BoxedImageName = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
`;
const Hline = styled.hr`
  border: none;
  height: 1px;
  width: 100%;
  background: #e0e0e0;
`;

// const ProfileImage = styled.img`
//   width: 70px;
//   height: 70px;
//   border-radius: 50%;
//   object-fit: cover;
//   border: 3px solid ${(props) => props.theme.primaryColor || '#007bff'};
// `;

const CardTitle = styled.h2`
  margin: 0;
  font-size: 17px;
  color: ${({ theme }) => theme.primaryColor};
`;

const CardContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const CardDetail = styled.div`
  display: flex;
  justify-content: space-between;
  /* background: #f8f9fa;
  padding: 0.6rem 1rem; */
  border-radius: 10px;

  span {
    font-size: 13px;
    font-weight: 400;
    color: #555;
  }

  strong {
    font-size: 13px;
    font-weight: 500;
    color: #111;
  }
`;
const TimeShow = styled.strong`
  font-size: 13px;
  font-weight: 500;
  color: #03a319ff !important;
`;
const CardContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 15px;
  border-radius: 12px;
  max-height: 69vh;
  overflow-y: scroll;

  &::-webkit-scrollbar {
    height: 0px;
    width: 0px;
    border-radius: 10px;
  }
  &::-webkit-scrollbar-track {
    width: 5px;
    background-color: normal;
    border-radius: 10px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: ${(props) => props.theme.primaryColor};
    border-radius: 10px;
  }
`;

const ClientBillingCard = ({ data }) => {
  return (
    <CardContainer>
      {data?.map((el) => {
        return (
          <>
            <Card>
              <BoxedImageName>
                {/* <ProfileImage
          src={user.profile_image || 'https://via.placeholder.com/70'}
          alt={user.name || 'User'}
        /> */}
                <CardTitle>{el?.name || 'N/A'}</CardTitle>
              </BoxedImageName>
              <Hline />
              <CardContent>
                <CardDetail>
                  <span>Email:</span>
                  <strong>{el?.email || 'N/A'}</strong>
                </CardDetail>
                {/* <CardDetail>
                  <span>Client ID:</span>
                  <strong>{el?.client_id || 'N/A'}</strong>
                </CardDetail> */}
                <CardDetail>
                  <span>Country:</span>
                  <strong>{el?.country || 'N/A'}</strong>
                </CardDetail>
                <CardDetail>
                  <span>State:</span>
                  <strong>{el?.state || 'N/A'}</strong>
                </CardDetail>
                <CardDetail>
                  <span>City:</span>
                  <strong>{el?.city || 'N/A'}</strong>
                </CardDetail>
                <CardDetail>
                  <span>Total Billing Time:</span>
                  <TimeShow>{formatMinToHours(el?.total_billable_mins || 0)}</TimeShow>
                </CardDetail>
              </CardContent>
            </Card>
          </>
        );
      })}
    </CardContainer>
  );
};

ClientBillingCard.propTypes = {
  data: PropTypes.array
};

export default ClientBillingCard;
export const SkeletonCardClient = () => {
  return (
    <CardContainer>
      {Array.from({ length: 7 }).map((_, i) => (
        <Card key={i} style={{ paddingTop: '5px', marginBottom: '0px', paddingBottom: 0 }}>
          <Skeleton active avatar paragraph={{ rows: 4 }} />
        </Card>
      ))}
    </CardContainer>
  );
};
